import template from "!!raw-loader!./ViewHeader.html";
import def from "csi/def";
import html from "csi/html";
import Widget from "csi/html/Widget";
import { pathCreate } from "csi/utility/pathUtility";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import ViewProofAction from "./Proof/ViewProofAction";

export = declare(Widget, {
	templateString: template,

	/**
	 * @override
	 * Specify toolbar plugins for task actions
	 */
	onViewCreate() {
		const defView = this.defView;
		const plugins = this.plugins = [];

		plugins.push(defView._addViewAction(new ViewProofAction(), {
			m_path: pathCreate(xml.ATTR_PARENT, xml.ATTR_PARENT),
			m_typeControl: def.ACTION_BUTTON,
			m_class: html.CSS_BUTTON_PRIMARY,
		}));
	},

	/**
	 * @override
	 * Toolbar is used to render completion actions
	 */
	_hasToolbar() {
		return true;
	},
});
